import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'status';
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default' }) => {
  if (variant === 'status') {
    return (
      <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-50 text-blue-700 text-sm font-semibold mb-8 border border-blue-100">
        <span className="flex h-2 w-2 rounded-full bg-blue-600 mr-2 animate-pulse"></span>
        {children}
      </div>
    );
  }

  return (
    <span className="px-3 py-1 bg-slate-100 text-slate-600 text-xs font-semibold rounded-full">
      {children}
    </span>
  );
};
